window.addEventListener('scroll', function () {
    const backToTopButton = document.querySelector('.back-to-top');
    if (window.scrollY > 300) { // Adjust the scroll threshold as needed
        backToTopButton.classList.add('is-visible');
    } else {
        backToTopButton.classList.remove('is-visible');
    }
});

document.querySelector('.back-to-top').addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});